export function PolyFeeToggle({ enabled, onChange, assumed = false }: {
  enabled: boolean; onChange: (enabled: boolean) => void; assumed?: boolean;
}): React.ReactElement {
  return <button type="button" className={`nx-pm-fee${enabled ? ' on' : ''}`} aria-pressed={enabled}
    aria-label="учитывать комиссию Polymarket"
    title={enabled ? `Комиссия Polymarket учтена${assumed ? ': стандартная спортивная ставка, проверьте условия рынка' : ''}. Сумма — весь расход со счёта` : 'Учитывать комиссию Polymarket. Сумма — весь расход со счёта'}
    onClick={e => { e.stopPropagation(); onChange(!enabled); }}>PM {enabled ? '✓' : '+'}</button>;
}
